const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    shop_ids: {
      type: 'array',
      title: 'فروشگاه',
      items: [],
    },
    user_id: {
      type: 'string',
      title: 'مالک',
    },
  },
});

export default schema;
